import BaseService from './BaseService';

class AuthenticationService extends BaseService {
    login = (data) => this.post('/warehouse/login', data);

    logout = () => this.get('/logout');
}

export default new AuthenticationService();